import enTargets from './en';
import ruTargets from './ru';

export default {
  en: {
    ...enTargets,
  },
  ru: {
    ...ruTargets,
  },
};
